import { useContext, useEffect, useMemo, useState } from 'react';

import { Form, Row, Table, TableProps } from 'antd';

import { InputFactory } from '../../../../../../../../../shared/components';
import { Modal } from '@hdi-seguros/web-components.modal';

import { ClientDataTableGrid } from '../../../../interfaces';
import { InputFactoryProp } from '../../../../../../../../../shared/interfaces';
import {
  GenericDataFormContext,
  StepOneFormContext,
} from '../../../../contexts';

import { ClientModalForm } from '../../../../../utils';

import './index.css';

const columns: TableProps<ClientDataTableGrid>['columns'] = [
  {
    title: 'Nombre',
    dataIndex: 'fullName',
    key: 'fullName',
    defaultSortOrder: 'ascend',
    sorter: (a: ClientDataTableGrid, b: ClientDataTableGrid) =>
      a.fullName.localeCompare(b.fullName),
  },
  {
    title: 'Tipo de Documento',
    dataIndex: 'documentType',
    key: 'documentType',
    defaultSortOrder: 'ascend',
    sorter: (a: ClientDataTableGrid, b: ClientDataTableGrid) =>
      (a.documentType || '').localeCompare(b.documentType || ''),
  },
  {
    title: 'Nro. de Documento',
    dataIndex: 'documentNumber',
    key: 'documentNumber',
  },
  {
    title: 'CUIT',
    dataIndex: 'cuit',
    key: 'cuit',
  },
  {
    title: 'IVA',
    dataIndex: 'ivaCondition',
    key: 'ivaCondition',
  },
];

export const ClientDataModal = () => {
  const [clientModalForm] = Form.useForm<ClientModalForm>();
  const [initialClients, setInitialClients] = useState<
    Array<ClientDataTableGrid>
  >([]);
  const [clientDataTable, setClientDataTable] = useState<
    Array<ClientDataTableGrid>
  >([]);

  const {
    clientListModalIsOpen,
    isLoadingClientList,
    onSelectClientOnTable,
    setClientListModalIsOpen,
    tableClientList,
  } = useContext(StepOneFormContext);

  const { ivaConditionList, documentTypeList, setCanShowSpinner } = useContext(
    GenericDataFormContext
  );

  const onFilterClients = () => {
    const { fullName, documentNumber, cuit, ivaCondition, documentType } =
      clientModalForm.getFieldsValue();

    let ivaConditionDescription: string;
    if (ivaCondition?.toString().length) {
      ivaConditionDescription =
        ivaConditionList?.find(
          (el) => el.value.toString() === ivaCondition.toString()
        )?.label ?? '';
    }

    let documentTypeDescription: string = '';

    if (documentType?.toString().length) {
      documentTypeDescription =
        documentTypeList?.find(
          (el) => el.value.toString() === documentType.toString()
        )?.label ?? '';
    }

    let filteredClients: Array<ClientDataTableGrid> = [];

    filteredClients = initialClients.filter(
      (client: ClientDataTableGrid) =>
        (fullName === undefined || fullName === '' ||
          (client.fullName && client.fullName.toLowerCase().includes(fullName.toLowerCase()))) &&
        (documentNumber === undefined || documentNumber === '' ||
          (client.documentNumber && client.documentNumber.includes(documentNumber))) &&
        (documentType === undefined ||
          documentTypeDescription === client.documentType) &&
        (ivaCondition === undefined ||
          ivaConditionDescription === client.ivaCondition.toString()) &&
        (cuit === undefined || cuit === '' || (client.cuit && client.cuit.includes(cuit)))
    );

    setClientDataTable(filteredClients);
  };

  const initialStateFilters: ClientModalForm = {
    fullName: '',
    documentType: undefined,
    documentNumber: '',
    cuit: '',
    ivaCondition: undefined,
  };

  const inputsFilter: InputFactoryProp[] = useMemo(
    () => [
      {
        element: 'input',
        type: 'text',
        placeHolder: 'Apellido y Nombre',
        name: 'fullName',
        columnSize: { xl: { span: 5 } },
      },
      {
        element: 'select',
        placeHolder: 'Tipo de Documento',
        items: documentTypeList,
        name: 'documentType',
        columnSize: { xl: { span: 4 } },
      },
      {
        element: 'input',
        type: 'text',
        placeHolder: 'Nro. de Documento',
        name: 'documentNumber',
        columnSize: { xl: { span: 5 } },
      },
      {
        element: 'input',
        type: 'text',
        placeHolder: 'CUIT',
        name: 'cuit',
        columnSize: { xl: { span: 5 } },
      },
      {
        element: 'select',
        placeHolder: 'IVA',
        items: ivaConditionList,
        name: 'ivaCondition',
        columnSize: { xl: { span: 5 } },
      },
    ],
    [documentTypeList, ivaConditionList]
  );

  const selectClient = async (client: ClientDataTableGrid) => {
    setCanShowSpinner(true);
    await onSelectClientOnTable(client.key);
    setCanShowSpinner(false);
  };

  const onClearFilters = () => {
    setInitialClients(tableClientList);
    setClientDataTable(tableClientList);
    clientModalForm.resetFields();
    onFilterClients();
  };

  useEffect(() => {
    if (tableClientList?.length) {
      setInitialClients(tableClientList);
      setClientDataTable(tableClientList);
      setCanShowSpinner(false);
    }
  }, [tableClientList]);

  return (
    <Modal
      centered
      open={clientListModalIsOpen}
      width='80rem'
      onCancel={() => setClientListModalIsOpen(false)}
      footer=''
      className='client-data-modal'
    >
      <Row align='middle' style={{ marginBottom: 15 }}>
        <InputFactory
          form={clientModalForm}
          items={inputsFilter}
          onFilter={onFilterClients}
          onClear={onClearFilters}
          initialState={initialStateFilters}
          className='input-factory-client-data-modal'
        />
      </Row>
      <Table
        columns={columns}
        dataSource={clientDataTable}
        loading={isLoadingClientList}
        style={{ cursor: 'pointer', marginTop: '20px' }}
        onRow={(client) => ({
          onClick: () => selectClient(client),
        })}
      />
    </Modal>
  );
};
